import React from 'react';
import { Box, Typography } from '@mui/material';
import MultiChannelTranscript from './MultiChannelTranscript';

import type { CombinedTranscript } from '@/types/transcript';

interface CallTranscriptContentProps {
    transcript: CombinedTranscript[] | null;
}

/**
 * Component that renders the content of a call transcript.
 *
 * @param {CallTranscriptContentProps} props
 * @returns {JSX.Element}
 */
const CallTranscriptContent: React.FC<CallTranscriptContentProps> = ({ transcript = null }) => {
    if (!transcript) {
        return (
            <Box sx={{ p: 2 }} data-testid="transcript-content">
                <Typography variant="body2" color="text.secondary">
                    No audio transcript available.
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }} data-testid="transcript-content">
            <MultiChannelTranscript transcript={Array.isArray(transcript) ? transcript : [transcript]} />
        </Box>
    );
};

export default CallTranscriptContent;
